import React from 'react';

export interface EntityHoverCardRenderer {
  render: (entity: any) => React.ReactNode;
  renderLoading?: () => React.ReactNode;
}

/**
 * Registry for entity-type-specific hover card renderers.
 *
 * Supports hierarchical prefix matching using dot-notation entity types
 * (e.g. "Communication.Thread" is tried before "Communication"). Apps
 * register their renderers at startup; the card system falls back to the
 * built-in generic renderer when no match is found.
 */
class EntityHoverCardRegistry {
  private renderers = new Map<string, EntityHoverCardRenderer>();

  register(entityType: string, renderer: EntityHoverCardRenderer): void {
    this.renderers.set(entityType, renderer);
  }

  /**
   * Look up a renderer by entity type with prefix fallback.
   * "Communication.Thread" → "Communication" → null
   */
  getRenderer(entityType: string): EntityHoverCardRenderer | null {
    if (!entityType) return null;

    const parts = entityType.split('.');
    for (let i = parts.length; i > 0; i--) {
      const key = parts.slice(0, i).join('.');
      const renderer = this.renderers.get(key);
      if (renderer) return renderer;
    }
    return null;
  }
}

export const entityHoverCardRegistry = new EntityHoverCardRegistry();
